export default __webpack_public_path__ + "static/media/followup-step.baaaf772.svg";